import React from 'react';
import PropTypes from 'prop-types';
import { annotationType } from 'types';

import Checkbox from 'components/Checkbox';

import './style.scss';

const MatchedAnnotationItem = ({ annotation, toggleAnnotation }) => (
  <li styleName="item" style={{ boxShadow: `-5px 0px ${annotation.color}` }}>
    <Checkbox
      isSmall
      title={!annotation.excluded ? 'Exclude entity' : 'Include entity'}
      isChecked={!annotation.excluded}
      onClick={toggleAnnotation}
      label={annotation.name}
    />
  </li>
);

MatchedAnnotationItem.propTypes = {
  annotation: annotationType,
  toggleAnnotation: PropTypes.func,
};

export default MatchedAnnotationItem;
